import React from 'react';
import { Tooltip as AntTooltip } from 'antd';
import { useTooltipsEnabled } from '../../contexts/TooltipsContext';

/* Tooltip antd qui ne se monte pas quand les infobulles sont coupées (cf.
   TooltipsContext) : le contenu est rendu tel quel, sans wrapper ni popup. */
const Tooltip = (props) => {
  const enabled = useTooltipsEnabled();
  return enabled ? <AntTooltip {...props} /> : <>{props.children}</>;
};

export default Tooltip;
